import { GoogleSigninResponse } from "./redux/services/api/types";

declare global {
  interface Window { googleLoginHandler: (response: GoogleSigninResponse) => void; }
}

export interface User {
  id?: number;
  uuid: string;
  name: string;
  lastName: string;
  fullName: string;
  email: string;
  picture: string;
  isPremium: boolean;
  new?: boolean;
  phoneNumber?: string;
}

export enum SubscriptionState {
  WAITING_FOR_PAYMENT = 'waiting_for_payment',
  ACTIVE = 'active',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
}

export function toSubscriptionState(value: string): SubscriptionState {
  switch (value) {
    case SubscriptionState.WAITING_FOR_PAYMENT:
      return SubscriptionState.WAITING_FOR_PAYMENT;
    case SubscriptionState.ACTIVE:
      return SubscriptionState.ACTIVE;
    case SubscriptionState.EXPIRED:
      return SubscriptionState.EXPIRED;
    case SubscriptionState.CANCELLED:
    default:
      return SubscriptionState.CANCELLED;
  }
}

export interface Subscription {
  id: string;
  userId: string;
  planId: string;
  state: SubscriptionState;
  startedAt: string;
  endsAt: string;
  showNotification?: boolean;
}

export enum UserAccountEvents {
  LOGGED = 'user-logged',
  LOGOUT = 'user-logout',
  BOOTSTRAPPED = 'authentication-bootstrap',
  USER_STATUS_REQUEST = 'user-status-request',
  USER_STATUS_RESPONSE = 'user-status-response',
}

export type UserLoggedEventData = {
  uuid: string;
  isPremium: boolean;
}
export type UserLogoutEventData = {
  uuid: string;
  isPremium: boolean;
}
export type AuthenticationBootstrappedEventData = {}
export type UserStatusRequestEventData = {}
export type UserStatusResponseEventData = {
  uuid?: string;
  isLogged: boolean;
  isPremium: boolean;
}

export class UserLoggedEvent extends CustomEvent<UserLoggedEventData> {
  constructor(data: UserLoggedEventData) {
    super(UserAccountEvents.LOGGED, { detail: data });
  }
}

export class UserLogoutEvent extends CustomEvent<UserLogoutEventData> {
  constructor(data: UserLogoutEventData) {
    super(UserAccountEvents.LOGOUT, { detail: data });
  }
}

export class AuthenticationBootstrappedEvent extends CustomEvent<AuthenticationBootstrappedEventData> {
  constructor(data: AuthenticationBootstrappedEventData = {}) {
    super(UserAccountEvents.BOOTSTRAPPED, { detail: data });
  }
}

export class UserStatusRequestEvent extends CustomEvent<UserStatusRequestEventData> {
  constructor(data: UserStatusRequestEventData = {}) {
    super(UserAccountEvents.USER_STATUS_REQUEST, { detail: data });
  }
}

export class UserStatusResponseEvent extends CustomEvent<UserStatusResponseEventData> {
  constructor(data: UserStatusResponseEventData) {
    super(UserAccountEvents.USER_STATUS_RESPONSE, { detail: data });
  }
}